const FALLBACK_APP_ICON =
  'https://cdn.thinkific.com/9/20191129/35cb10b56e4ff39a55aa99f800ff52d2.jpg';

export default FALLBACK_APP_ICON;
